import Logo from "../../../../components/commonComponents/header/Logo";

const RenderTrueFalse = ({ question, selectedAnswer, setSelectedAnswer }) => {
  return (
    <div className="w-full flex">
      {/* Logo - 20% */}
      <div className="w-1/10 flex-shrink-0 flex items-start">
        <Logo />
      </div>

      {/* Question + Options - 80% */}
      <div className="w-9/10">
        <div className="text-center mb-8">
          <h1 className="text-questionPrimaryFontSize font-medium mb-8 common-font">
            A Quick Question! Read and Answer carefully.
          </h1>
          <p className="text-questionSecondaryFontSize mb-8 font-medium text-fontColor">
            For the statement below, choose either True or False
          </p>
        </div>

        {/* Question Statement + Radio Buttons */}
        <div className="flex flex-col items-start space-y-4 px-20">
          <h2 className="text-questionTertiaryFontSize font-medium text-purple-750">
            {question.title}
          </h2>
          {["True", "False"].map((option) => (
            <label
              key={option}
              className="flex items-center space-x-3 cursor-pointer"
            >
              <input
                type="radio"
                name="true-false"
                value={option}
                checked={selectedAnswer === option}
                onChange={() => setSelectedAnswer(option)}
                className="form-radio h-5 w-5 accent-[#6D44FD] border-gray-300 "
              />
              <span className="text-questionTertiaryFontSize font-medium text-fontColor">
                {option}
              </span>
            </label>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RenderTrueFalse;
